import { type ComponentProps } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { MessageRegular } from './message-regular';
import { NewMessageDivider } from './new-messages-divider';
import { ReplyIndicator } from './reply-indicator';

interface MessageRegularVirtuosoProps extends ComponentProps<typeof MessageRegular> {
  className?: string;
  isThreadFirstMessage?: boolean;
  /** This is the line that indicates where a user had last caught up to */
  showNewLine: boolean;
}

export const MessageRegularVirtuoso = ({
  showNewLine,
  message,
  isHighlighted,
  isEditing,
  onStartEditing,
  onCancelEditing,
  onClick,
  onDelete,
  isThread,
  className,
  isThreadFirstMessage = false,
}: MessageRegularVirtuosoProps) => {
  if (message.type === 'system') {
    return <SystemMessage>{message.text}</SystemMessage>;
  }

  return (
    <>
      {showNewLine && <NewMessageDivider />}
      <MessageRegular
        className={className}
        message={message}
        isHighlighted={isHighlighted}
        isEditing={isEditing}
        onStartEditing={onStartEditing}
        onCancelEditing={onCancelEditing}
        isThread={isThread}
        onClick={onClick}
        onDelete={onDelete}
      />
      {isThreadFirstMessage && <ReplyIndicator replyCount={message.replyCount} />}
    </>
  );
};
MessageRegularVirtuoso.displayName = 'MessageRegularVirtuoso';

const SystemMessage = ({ children }: { children: string }) => {
  return <li css={systemMessageStyles}>{children}</li>;
};

const systemMessageStyles = css({
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.colors.neutral50,
  fontSize: theme.fontSize(12),
  fontWeight: theme.font.weight.regular,
});
